import React, { memo } from 'react'

import { Icon, ChevronDown, ChevronUp, SettingsOutline, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const size = { height: '14px', width: '14px' }

function AdvancedSettingsTrigger({ isExpanded, onClick: handleClick }) {
  const t = useTranslation()

  return (
    <button
      type="button"
      onClick={handleClick}
      className={classnames(
        'advanced-settings__trigger',
        isExpanded && 'advanced-settings__trigger--expanded',
      )}
      aria-expanded={isExpanded}
    >
      <span className="advanced-settings__trigger-title">
        <Icon svgComponent={SettingsOutline} size={size} color="dark" notSpaced aria-hidden="true" />
        <span className="advanced-settings__trigger-label cgt-body-base-semibold">
          {t('leftSide.advancedSettings.trigger')}
        </span>
      </span>
      <Icon
        svgComponent={isExpanded ? ChevronUp : ChevronDown}
        size={size}
        color="dark"
        notSpaced
        aria-hidden="true"
      />
    </button>
  )
}

AdvancedSettingsTrigger.propTypes = {
  isExpanded: bool.isRequired,
  onClick: func.isRequired,
}

export default memo(AdvancedSettingsTrigger)
